import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './Index.sass'
import { ProductProvider } from './Components/Context/Context';


// ReactDOM.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
//   document.getElementById('nordoel_heizoel_app')
// );

const container = document.getElementById('nordoel_heizoel_app');
const root = createRoot(container)
root.render(<ProductProvider><App /></ProductProvider>)

